import { createFileRoute } from '@tanstack/react-router';
import { QualityStats } from '@/features/insights/QualityStats';

export const Route = createFileRoute('/_app/quality')({ component: QualityStats });
